import angular from "angular"

let mod = angular
    .module('customFilters', [])
    .filter('timerStr', function () {
        return function (val) {
            let minutes = Math.floor(val / 60);
            let seconds = Math.floor(val % 60);
            if (minutes < 10) {
                minutes = '0' + minutes;
            }
            if (seconds < 10) {
                seconds = '0' + seconds;
            }
            return minutes + ':' + seconds;
        }
    })
    .filter('carTypeLabel', function () {
        return function (type) {
            switch (type) {
                case (1):
                    return 'Общий';
                case (2):
                    return 'Сидячий';
                case (3):
                    return 'Плацкарт';
                case (4):
                    return 'Купе';
                case (5):
                    return 'Мягкий';
                case (6):
                    return 'Люкс';
            }
            return null;
        }
    });

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/app/customFilters.js